module.exports = __webpack_public_path__ + "img/office.b2b093a0.svg";